import { mapGetters } from 'vuex'
import RowSectionHeader from '@/components/rows/SectionHeader.vue'
import RowVerticalCenter from '@/components/rows/VerticalCenter.vue'

export default {
  name: 'affixed-section-base',
  components: {
    RowSectionHeader,
    RowVerticalCenter,
  },
  props: {
    section: Object,
    side: {
      type: String,
      required: false,
    }
  },
	computed: {
		...mapGetters(['containerSize']),
	},
  methods: {
    isRight: function (side) {
      return (side == 'right')
    },
    isLeft: function (side) {
      return (side == 'left')
    },
    getSectionContents: function () {
      return Object.assign(this.section, this.sectionContents)
    },
		getContainerMarginLeft: function () {
			return (this.containerSize.marginLeft + 15)
    },
    fakeContainerStyle: function () {
			if (window.innerWidth < 768) {
				// Mobile should have no custom style here
				return
			}
			return {
        marginRight: this.getContainerMarginLeft() / 2 + 'px',
        marginLeft: this.getContainerMarginLeft() / 2 + 'px',
			}
    },
		affixComponentStyle: function (isFluid) {
			// Getting bootstrap component's width for the right side
			if (window.innerWidth < 768) {
				// Mobile should have no custom style here
				return
      }
      const margin = isFluid ? (- this.getContainerMarginLeft() + 15) : 15
			return {
        width: ((this.containerSize.width / 2) - margin) + 'px',
        left: '-15px',
			}
		},
  },
}



// WEBPACK FOOTER //
// ./src/components/AffixedSectionBase.js